import React, { forwardRef } from 'react';
import { ChartContext } from '../../contexts';
var ChartBase = forwardRef(function (_a, ref) {
    var theme = _a.theme, xScaleSettings = _a.xScaleSettings, yScaleSettings = _a.yScaleSettings, svgDimensions = _a.svgDimensions, margins = _a.margins, children = _a.children;
    return (React.createElement(ChartContext.Provider, { value: {
            theme: theme,
            xScaleSettings: xScaleSettings,
            yScaleSettings: yScaleSettings,
            svgDimensions: svgDimensions,
            margins: margins,
        } },
        React.createElement("svg", { ref: ref, xmlns: "http://www.w3.org/2000/svg", role: "img", preserveAspectRatio: "xMinYMin", width: "100%", height: "100%" }, children)));
});
ChartBase.displayName = 'ChartBase';
export default ChartBase;
